export default __webpack_public_path__ + "static/media/btn_big_bsc.5e5ec82b.png";